import { countries } from './countries';

// check if given country is or matches a valid 2 letter country code
export default function getValidCountryCode(country) {
  if (country.length === 2) {
    // check if country is a valid 2 letter country code
    const match = countries.find(c => c.alpha2 === country.toUpperCase());

    if (match) {
      return match.alpha2;
    }
  }

  // check if country is a valid country name
  const match = countries.find(c => c.name === country);

  if (match) {
    return match.alpha2;
  }
}
